/**
 * 扫描仪
 * 2019-05-29 chenxiaojian
 */
import React from 'react';
import { Modal, Button,Switch } from 'antd';

import '../../style/common/uploadImage.css';

// 扫描仪设备，通过 scannerObject().Global_CreateDevice(1, idx) 创建
var scannerDevice = null;
// 当前打开的扫描仪对象，通过  scannerObject().Device_CreateVideo(scannerDevice, resolution, transportFormat) 创建
var scannerVideo = null;
//图片路径
// var picturePath;

/**
 * 判断浏览器是否支持插件
 * @returns
 */
function enableActiveXObject() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return true;
    } else {
        return false;
    }
}

//设备的html对象
function scannerObject() {
    return document.getElementById('scannerObject');
}

//加载扫描仪
function loadDevice() {
    //设备接入和丢失
    //type设备类型， 1 表示视频设备， 2 表示音频设备
    //idx设备索引
    //dbt 1 表示设备到达， 2 表示设备丢失
    let flag = addEvent(scannerObject(), 'DevChange', function (type, idx, dbt) {
        if (1 === type) {
            //视频设备
            if (1 === dbt) {
                //设备到达
                var deviceType = scannerObject().Global_GetEloamType(1, idx);
                if (1 === deviceType) {
                    //主摄像头
                    if (null == scannerDevice) {
                        //创建扫描仪html对象
                        scannerDevice = scannerObject().Global_CreateDevice(1, idx);
                        if (scannerDevice) {
                            //获取设备名称，并在页面上显示
                            document.getElementById('scannerName').innerHTML =
                                scannerObject().Device_GetFriendlyName(scannerDevice);
                            //修改传输格式和分辨率
                            changeTransportFormat();
                            //打开扫描仪
                            openScannerVideo();
                        }
                    }
                }
            }
        }
    });
    if(! flag) return false;
    // 设置窗口名称  Name “view”表示预览窗口，”thumb”表示缩略图
    scannerObject().Global_SetWindowName("view");
    //thumbObject().Global_SetWindowName("thumb");
    // var res = scannerObject().Global_DeinitDevs();
    // var ret = scannerObject().Global_InitDevs();
    scannerObject().Global_DeinitDevs();
    scannerObject().Global_InitDevs();
}

//修改传输格式
function changeTransportFormat() {
    // 现在绝大多数摄像头所采用的是免驱摄像头，一般有两种传输格式，YUY2和MJPG，
    // 前者是无压缩图像格式的视频，系统资源占用少（因为不用解码），不需要解码器，缺点是帧率稍慢（受限于USB分配的带宽），
    // 后者是相当于JPEG图像压缩格式，优点是帧率高（视频开启快，曝光快），缺点是影像有马赛克，并且需要解码器，会占用PC系统资源
    if (scannerDevice) {
        //获取当前的传输格式
        var transportFormat = document.getElementById('transportFormat').value;
        transportFormat = parseInt(transportFormat);
        //分辨率选择下拉框
        var resolutionSelect = document.getElementById('resolutionSelect');
        //获取当前设备支持的分辨率			
        var resolution = scannerObject().Device_GetResolutionCountEx(scannerDevice, transportFormat);
        resolutionSelect.options.length = 0;
        for (var i = 0; i < resolution; i++) {
            var width = scannerObject().Device_GetResolutionWidthEx(scannerDevice, transportFormat, i);
            var heigth = scannerObject().Device_GetResolutionHeightEx(scannerDevice, transportFormat, i);
            resolutionSelect.add(new Option(width.toString() + "*" + heigth.toString()));
        }
        resolutionSelect.selectedIndex = 0;
    }
}

//打开扫描仪
function openScannerVideo() {
    //先关闭之前打开的，如果有打开了的话
    closeScannerVideo();
    //如果没有扫描仪直接返回
    if (!scannerDevice) return;
    //传输格式
    var transportFormat = document.getElementById('transportFormat').value;
    transportFormat = parseInt(transportFormat);
    //分辨率
    var resolutionSelect = document.getElementById('resolutionSelect');
    var resolution = resolutionSelect.selectedIndex;
    //打开视频
    scannerVideo = scannerObject().Device_CreateVideo(scannerDevice, resolution, transportFormat);
    if (scannerVideo) {
        scannerObject().View_SelectVideo(scannerVideo);
        scannerObject().View_SetText("打开视频中，请等待...", 0);
    }
}

//关闭扫描仪
function closeScannerVideo() {
    if (scannerVideo) {
        scannerObject().Video_Release(scannerVideo);
        scannerVideo = null;
        scannerObject().View_SetText("", 0);
    }
}

//添加事件
function addEvent(obj, name, func) {
    let flag = false;
    try {
        if (obj.attachEvent) {
            obj.attachEvent("on" + name, func);
        } else {
            obj.addEventListener(name, func, false);
        }
        flag = true;
    }
    catch(err) {
    }
    return flag;
}

function init() {
    if (!enableActiveXObject()) {
        //如果浏览器不支持activeX 则直接返回
        return;
    }
    //先释放掉扫描仪的一些资源
    closeScannerVideo();
    scannerDevice = null;
    //加载扫描仪
    loadDevice();
}

function setManualSelection(value) {
    if (value) {
        scannerObject().View_SetState(2);
    } else {
        scannerObject().View_SetState(1);
    }
}

//拍照
function doScan() {
    //判断扫描仪是否存在
    if (scannerVideo) {
        var img = scannerObject().Video_CreateImage(scannerVideo, 0, scannerObject().View_GetObject());
        //图片名称
        /* var name = scannerObject().Global_GetTempName("jpg");
        var bSave = scannerObject().Image_Save(img, name, 0);
        if (bSave) {
            scannerObject().View_PlayCaptureEffect();
            thumbObject().Thumbnail_Add(name);
        } */
        //图像格式，-1 表示未知，0 表示bmp，1 表示ico，2 表示jpeg ，13 表示png，18 表示tiff ，25 表示gif
        //将base64的图片赋给全局变量，以便后面处理
        let current_scanner_picture = scannerObject().Image_GetBase64(img, 2, 0);
        //释放掉图片句柄
        scannerObject().Image_Release(img);
        //关闭窗口
        //this.closeDialog();
        //返回拍照的图片
        return current_scanner_picture;
    }
    return null;
}

//图片左旋
function turnLeft() {
    if (scannerVideo) {
        scannerObject().Video_RotateLeft(scannerVideo);
    }
}
//图片右旋
function turnRight() {
    if (scannerVideo) {
        scannerObject().Video_RotateRight(scannerVideo);
    }
}

class Scanner extends React.Component {

    state = {
        initScannerFlag : false
    }

    componentDidMount() {
        if(this.props.initScanner !== undefined && this.props.initScanner != null){
            this.props.initScanner(this.scannerInit);
        }
    }

    getDom = () => {
        let dom = document.getElementById("scannerObject");
        if (dom == null) {
            let that = this;
            setTimeout(function () {
                that.getDom();
            }, 1000);
        }else{
            this.setState({initScannerFlag: true});
            init();
        }
    }

    scannerInit = () => {
        if(this.state.initScannerFlag){
            openScannerVideo();
        }else{
            this.getDom();
        }
    }

    scan = () =>{
        let image = doScan();
        this.props.onScan(image);
        closeScannerVideo();
        this.props.onCancel();
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="扫描仪"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                footer={[
                    <Button key="left" type="dashed" onClick={turnLeft}>左转</Button>,
                    <Button key="right" type="dashed" onClick={turnRight}>右转</Button>,
                    <Button key="open" type="dashed" onClick={openScannerVideo}>打开视频</Button>,
                    <Button key="close" type="dashed" onClick={closeScannerVideo}>关闭视频</Button>,
                    <Button key="take" type="primary" onClick={this.scan}>拍照</Button>,
                    <Button key="hide" type="" onClick={onCancel}>关闭</Button>,
                ]}
            // afterClose={() => {
            // }}
            >
                <div>
                    <div style={{ textAlign: 'center', margin: 10 }}>
                        <object id="scannerObject" type="application/x-eloamplugin" style={{ width: '100%', height: 400 }} name="view" aria-label=""/>
                    </div>
                    <div>
                        <table style={{width: "100%"}}>
                            <tbody>
                                <tr>
                                    <td style={tdTitle}>当前设备：</td>
                                    <td style={tdContent}><span id="scannerName" /></td>
                                    <td style={tdTitle}>传输格式：</td>
                                    <td style={tdContent}>
                                        <select id="transportFormat" onChange={changeTransportFormat} style={{width:'80%'}} defaultValue={2}>
                                            <option value={2}>MJPG</option>
                                            <option value={1}>YUY2</option>
                                        </select>
                                    </td>
                                    <td style={tdTitle}>分辨率：</td>
                                    <td style={tdContent}>
                                        <select id="resolutionSelect" style={{width:'80%'}}/>
                                    </td>
                                    <td style={tdTitle}>
                                        手动框选:
                                    </td>
                                    <td style={tdContent}>
                                        <Switch checkedChildren="开" unCheckedChildren="关" onChange={setManualSelection} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        );
    }
}

const tdTitle ={width: '70px'}
const tdContent ={width: '130px', textAlign: "left"}

export default Scanner;